
(function(){
 function bindSmartFit(){
   var b=document.getElementById('mpSmartFitOpen');
   if(!b||b.dataset.bound)return;
   b.dataset.bound='yes';
   b.addEventListener('click',function(){
     var existing=document.getElementById('openSize');
     if(existing){existing.click();return;}
     var modal=document.getElementById('sizeModal');
     if(modal){modal.classList.add('show');modal.setAttribute('aria-hidden','false');}
   });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bindSmartFit);else bindSmartFit();
})();
